/* global document, MutationObserver, window */

/**
 * Main menu hovers, accessibility, and mobile menu behaviors.
 */
import hoverintent from 'hoverintent';
import includes from 'lodash/includes';
import map from 'lodash/fp/map';

const mainMenu = ($) => {

  // Injects the site logo and close button into the first panel title area.
  const injectHeaderElements = () => {
    const mmPanel = document.getElementById('mm-1');
    const mmTitle = mmPanel?.querySelector('.mm-navbar__title');

    if (mmTitle && !mmTitle.querySelector('.navbar-brand')) {
      // Create the logo element
      // const logoLink = document.createElement('a');
      // logoLink.href = '/';
      // logoLink.className = 'navbar-brand';

      // const logoImg = document.createElement('img');
      // logoImg.src = '/themes/custom/summit_theme/logo.svg';
      // logoImg.alt = 'Site Logo';

      // logoLink.appendChild(logoImg);

      // Create the close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'mm-close';
      closeBtn.setAttribute('aria-label', 'Close menu');
      closeBtn.innerHTML = 'Close menu';

      // Append both to the navbar title
      //mmTitle.appendChild(logoLink);
      mmTitle.appendChild(closeBtn);

      // Add event listener to close menu
      closeBtn.addEventListener('click', () => {
        const mmApi = document.querySelector('#off-canvas')?.mmApi;
        mmApi?.close?.(document.getElementById('off-canvas'));
      });
    }
  };

  // Run logo.close button once on init
  injectHeaderElements();

  // Duplicate the secondary nav for the mobile menu
  const duplicateSecondaryNav = () => {
    const offCanvas = document.getElementById('off-canvas');
    if (!offCanvas) return false;
    const listview = offCanvas.querySelector('.mm-listview');
    if (!listview) return false;
    const secondaryNav = document.querySelector('.menu--secondary');
    const mobileSecondaryNav = secondaryNav.cloneNode(true);
    // mobileSecondaryNav.removeAttribute('id');
    listview.after(mobileSecondaryNav);
    return true;
  };

  // If secondary nav is not successfully duplicated, watch body mutations until
  // it is.
  if (!duplicateSecondaryNav()) {
    // Observe body for mmenu in order to duplicate and place the mobile
    // secondary nav
    const observer = new MutationObserver((mutations, o) => {
      if (duplicateSecondaryNav()) o.disconnect();
    });

    observer.observe(document.body, {
      attributes: false,
      characterData: false,
      childList: true,
      subtree: true,
    });
  }
}

export default mainMenu;
